/*
Builds the "Sommaire" table of contents from the rendered article: an h2 list
where the h3s of the current section are the only ones on show. The current
section is the last heading above 30% of the viewport.
*/

function slugify(text) {
    return (
        text
            .toLowerCase()
            .replace(/[^\w\s-]/g, '')
            .trim()
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-') || 'section'
    );
}

function ensureIds(headings) {
    const seen = new Set();
    document.querySelectorAll('[id]').forEach((el) => seen.add(el.id));

    headings.forEach((heading) => {
        if (heading.id) {
            return;
        }

        const base = slugify(heading.textContent);
        let id = base;
        let n = 1;

        while (seen.has(id)) {
            n += 1;
            id = `${base}-${n}`;
        }

        seen.add(id);
        heading.id = id;
    });
}

function renderList(headings) {
    const list = document.createElement('ol');
    list.className = 'toc-list';

    headings.forEach((heading) => {
        const item = document.createElement('li');
        item.className = heading.tagName.toLowerCase();

        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;

        item.appendChild(link);
        list.appendChild(item);
    });

    return list;
}

export default function toc() {
    const aside = document.querySelector('.gh-toc');
    const mobile = document.querySelector('.gh-toc-mobile');

    if (!aside && !mobile) {
        return;
    }

    const content = document.querySelector('.gh-content');
    const headings = content ? Array.from(content.querySelectorAll('h2, h3')) : [];

    // Nothing worth summarising
    if (headings.filter((h) => h.tagName === 'H2').length < 2) {
        return;
    }

    ensureIds(headings);

    if (aside) {
        aside.appendChild(renderList(headings));
        aside.hidden = false;
    }

    if (mobile) {
        mobile.appendChild(renderList(headings));
        mobile.hidden = false;
    }

    const links = Array.from(document.querySelectorAll('.toc-list a'));
    const byId = new Map();

    links.forEach((link) => {
        const id = link.getAttribute('href').slice(1);
        byId.set(id, (byId.get(id) || []).concat(link));
    });

    let current = null;

    function update() {
        const limit = window.innerHeight * 0.3;
        let active = null;

        for (const heading of headings) {
            if (heading.getBoundingClientRect().top <= limit) {
                active = heading;
            } else {
                break;
            }
        }

        if (active === current) {
            return;
        }

        current = active;
        links.forEach((link) => link.classList.remove('on'));
        document.querySelectorAll('.toc-list li.h3').forEach((li) => li.classList.remove('show'));

        // The current h2 is the active heading itself, or the nearest h2 above it
        let section = active;
        while (section && section.tagName !== 'H2') {
            section = section.previousElementSibling;
        }

        if (section) {
            (byId.get(section.id) || []).forEach((link) => {
                let next = link.parentElement.nextElementSibling;
                while (next && next.classList.contains('h3')) {
                    next.classList.add('show');
                    next = next.nextElementSibling;
                }
            });
        }

        if (active) {
            (byId.get(active.id) || []).forEach((link) => {
                link.classList.add('on');
                if (aside && aside.contains(link)) {
                    link.scrollIntoView({block: 'nearest'});
                }
            });
        }
    }

    addEventListener('scroll', update, {passive: true});
    addEventListener('resize', update, {passive: true});
    update();
}
